import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGalleries, removeGallery } from '../../../slice/gallerySlice';
import AdminTable from 'common/AdminTable';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

const List = () => {
    const dispatch = useDispatch();
    const { data: galleries, loading, error } = useSelector((state) => state.gallery);

    useEffect(() => {
        dispatch(getGalleries());
    }, [dispatch]);

    const getImageUrl = (imgJson) => {
        try {
            const images = JSON.parse(imgJson);
            const firstImg = images[0];
            const backend = process.env.REACT_APP_BACKEND || 'http://localhost:8001/';
            const base = backend.endsWith('/') ? backend : backend + '/';
            return `${base}uploads/${firstImg.trim()}`;
        } catch (e) {
            return '';
        }
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#e67e22',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeGallery(id));
            }
        });
    };

    const tableHeaders = [
        { Header: 'ID', accessor: 'id' },
        { Header: 'Title', accessor: 'title' },
        {
            Header: 'Image',
            accessor: 'images',
            Cell: ({ value }) => (
                <img src={getImageUrl(value)} alt="" width="100" className="rounded shadow-sm" />
            ),
        },
        { Header: 'Location', accessor: 'location' },
        { Header: 'Status', accessor: 'status', Cell: ({ value }) => (value === 1 ? 'Active' : 'Inactive') },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <>
                    <button className="btn removebtn mx-1" onClick={() => handleDelete(row.original.id)}>
                        Remove
                    </button>
                    <Link to={`/khajuraho/gallery/update/${row.original.id}`} className="btn editbtn mx-1">
                        Edit
                    </Link>
                </>
            ),
        },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4 d-flex justify-content-between align-items-center">
                <h4 className="text-white font-weight-bold">Khajuraho Gallery</h4>
                <Link to="/khajuraho/gallery/add" className="btn btn-light btn-sm font-weight-bold">
                    Add Gallery Item
                </Link>
            </div>
            <div className="mt-4">
                {loading ? (
                    <div className="text-center py-5">
                        <div className="spinner-border text-light" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : error ? (
                    <div className="alert alert-danger mx-4">Error: {error}</div>
                ) : galleries?.length > 0 ? (
                    <AdminTable tableHeaders={tableHeaders} tableData={galleries} />
                ) : (
                    <div className="text-center text-white py-5">No gallery items found.</div>
                )}
            </div>
        </div>
    );
};

export default List;
